import * as moment from 'moment';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './holdings.reducer';
import { HoldingsFilter } from './holdings.models';
import { DatesInterval } from '../../global/interfaces';
import { getYearsDropdownValues, getMonthsDropdownValues } from '../../global/dates';

export const selectHoldingsState = createFeatureSelector<State>('holdings');

export const selectHoldingsLoading = createSelector(selectHoldingsState, (state: State) => state.loading);

export const selectHoldingsData = createSelector(selectHoldingsState, (state: State) => state.data);

export const selectHoldingsFilter = createSelector(selectHoldingsState, (state: State) => state.filter);

export const selectHoldingsYearFilter = createSelector(selectHoldingsFilter, (state?: HoldingsFilter) => state ? state.year : undefined);

export const selectHoldingsMonthFilter = createSelector(selectHoldingsFilter, (state?: HoldingsFilter) => state ? state.month : undefined);

export const selectHoldingsAllocationType = createSelector(selectHoldingsFilter, (state?: HoldingsFilter) => state?.allocationType || 'managerAllocations');

export const selectHoldingsDate = createSelector(selectHoldingsFilter, (filter?: HoldingsFilter) => {
  if (!filter || filter.year === undefined || filter.month === undefined) {
    return undefined;
  }

  return moment.utc({ year: filter.year, month: filter.month }).startOf('month').format('YYYY-MM-DD');
});

export const selectHoldingsDates = createSelector(selectHoldingsState, (state?: State) => state ? state.dates : undefined);

export const selectHoldingsDatesMin = createSelector(selectHoldingsDates, (dates?: DatesInterval) =>
  dates ? moment.utc(dates.min) : undefined
);

export const selectHoldingsDatesMax = createSelector(selectHoldingsDates, (dates?: DatesInterval) =>
  dates ? moment.utc(dates.max) : undefined
);

export const selectHoldingsYears = createSelector(
  selectHoldingsDatesMin,
  selectHoldingsDatesMax,
  (min?: moment.Moment, max?: moment.Moment) => getYearsDropdownValues(min, max)

);

export const selectHoldingsMonths = createSelector(
  selectHoldingsYearFilter,
  selectHoldingsDatesMin,
  selectHoldingsDatesMax,
  (year?: number, min?: moment.Moment, max?: moment.Moment) => getMonthsDropdownValues(year, min, max)

);
